import { PermissionsEnum } from '@/auth/interfaces';
import { useFetchSystemPermissions } from '@/shared/actions/erp';
import { useCheckPermissionsArray, useLoaders } from '@/shared/hooks';
import { SaveGrupoSistema } from '../../shared/components';

export type CreateGrupoSistemaPageProps = {};

const CreateGrupoSistemaPage: React.FC<CreateGrupoSistemaPageProps> = () => {
  useCheckPermissionsArray([
    PermissionsEnum.auth_add_group,
    PermissionsEnum.auth_view_permission,
  ]);

  ///* fetch data
  const {
    data: systemPermissionsRes,
    isLoading,
  } = useFetchSystemPermissions({
    enabled: true,
    params: {
      page_size: 6000,
    },
  });
  useLoaders(isLoading);

  if (isLoading) return null;

  return (
    <SaveGrupoSistema
      title="Crear Grupo de Sistema"
      userPermissions={systemPermissionsRes?.data || []}
      userPermissionsSelected={[]}
    />
  );
};

export default CreateGrupoSistemaPage;
